'use client'

import { PrismicRichText } from "@prismicio/react";
import { useEffect } from "react";

const SideMenu = ({ page, isMobileViewer }) => {

  useEffect(() => {
    const $sumUpTrigger = Array.from(document.querySelectorAll('.sumup-trigger'));
    if ($sumUpTrigger !== null) obeserveSubMenu($sumUpTrigger);
  });

  function goToSection(e) {
    const text = e.target.dataset.pointer

    const d = document.getElementById(text);
    window.scrollTo({
      behavior: 'smooth',
      top:
        d.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        110,
    })
  }

  function obeserveSubMenu(elems) {
    const obs = {
      rootMargin: '',
      threshold: 1,
    }

    function cb(entries) {
      entries.forEach(entry => {
        if (!isMobileViewer) {
          if (entry.isIntersecting) {
            document.querySelectorAll(".article-sumup-title").forEach(e => e.classList.add("lg:opacity-50"))
            document.querySelector(`[data-pointer="${entry.target.id}"]`).classList.remove("lg:opacity-50")
          }
        }

      });
    };
    const observer = new IntersectionObserver(cb, obs);
    elems.forEach(element => observer.observe(element));
  }

  return <div className="mx-30px sumup-wrapper py-2">
    {
      page.data.slices.filter(slice => slice.slice_type == 'article_rich_text').map((elem, i) => <PrismicRichText
        key={i}
        field={elem.primary.text.filter(elem => elem.type === 'heading2')}
        components={{
          heading2: ({ children, text }) => <div className="py-3.5" onClick={goToSection}>
            <h4 data-pointer={`${text.split(" ").join("-").split("'").join("-").split(':').join('').split('(').join('').split(')').join('').split('--').join('-')}`} className="cursor-pointer article-sumup-title transition-opacity">{children}</h4>
          </div>,
        }} />
      ) //serializerSumUp
    }
  </div>

}

export default SideMenu